const MarqueNotice = () => {
  const banglaNotice = (
    <span className='text-bangla'>
      <span style={{ color: 'red' }}>নোটিশঃ </span>
      তিন দিনের মধ্যে স্টলের পেমেন্ট সম্পন্ন না করলে বুকিং বাতিল করে দেওয়া হবে।
    </span>
  );
  return (
    <div>
      <div className='marquee-container'>
        <div className='marquee-track'>
          {banglaNotice}
          <span className='text-english'>
            <span style={{ color: 'red' }}>Notice: </span>
            If the stall payment is not completed within three days, the booking
            will be cancelled.
          </span>
          {banglaNotice}
        </div>
      </div>
    </div>
  );
};

export default MarqueNotice;
